import { useQuery } from 'react-query'
import { useMainContext } from '../../contexts/main'
import {filterFetch, normalFetch} from '../fetch-api/get'

const useMarketQuery = () => {
	const {
		profile: { token },
	} = useMainContext()

	return useQuery('fetch-market', () => normalFetch(token, 'market'), {
		enabled: !!token,
		refetchOnWindowFocus: false,
		staleTime: 5 * 60 * 1000,
		select: (res) => res.data?.data,
	})
}

const useGetDailyBalance = (params = {}) => {
	const {
		profile: { token },
	} = useMainContext()
	return useQuery(
		'daily-balance', () => filterFetch(params, token, `dailyBalance`, ),
		{
			enabled: !!token,
			refetchOnWindowFocus: false,
			select: (res) => res.data?.data,
		}
	)
}


const useGetDailyRecords = (params = {}) => {
	const {
		profile: { token },
	} = useMainContext()
	return useQuery(
		'daily-record', () => filterFetch(params, token, `dailyRecords`),
		{
			enabled: !!token,
			refetchOnWindowFocus: false,
			select: (res) => res.data?.data,
		}
	)
}

export { useMarketQuery, useGetDailyBalance, useGetDailyRecords }
